import React from 'react';
import { IIconProps } from './utils';

// AIDEV-NOTE: Deliberately shares Check's 18x14 viewBox and its 2.5-unit stroke thickness, so
// rendering the two at the same `size` gives them the same weight. That pairing is what a
// checkbox's checked and partial states need; don't "tidy" this to a square viewBox.
export const Minus = ({
  fill = 'currentColor', height = 30, width = 30, ...rest
}: IIconProps) => (
  <svg
    fill="none"
    height={height}
    viewBox="0 0 18 14"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <rect fill={fill} height="2.5" rx="1.25" width="17" x="0.5" y="5.75" />
  </svg>
);
